"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
exports.default = vue_1.default.extend({
    name: 'JovianMultiplier',
    props: {
        amount: {
            type: Number,
        },
    },
    methods: {},
});
